import { Page } from '@app/components/page/Page';
import { StationGroupsIcon } from '@app/components/stations/StationGroupsIcon';
import { ListViewLocal } from '@app/core/list-view/ListViewLocal';
import { isSharedStationGroup } from '@app/core/stations/helpers';
import { MinimumStationsGroup } from '@app/core/types/stations';
import { stationsStationsGroupsList } from '@mi-front/api-v2';
import { useIntl } from 'react-intl';
import { stationGroupsMessages } from '../station-groups-messages';
import { AdminStationGroupsList } from './AdminStationGroupsList';
import { ADMIN_STATION_GROUPS_FILTERS_CONFIG } from './filters/admin-station-groups-filters-config';

/**
 * Admin list of owned station groups: loads once, excludes shared groups, filters locally.
 */
export function AdminStationGroupsListPage() {
  const { $t } = useIntl();
  const title = $t(stationGroupsMessages.listTitle);

  const queryFn = async (): Promise<MinimumStationsGroup[]> => {
    const data = await stationsStationsGroupsList();
    const groups = data as unknown as MinimumStationsGroup[];
    // Admin manages owned groups only — shared-from-another-client groups stay out of this list.
    return groups.filter((group) => !isSharedStationGroup(group));
  };

  return (
    <Page data-cy="station-groups-list-screen" htmlTitle={title}>
      <Page.Header icon={<StationGroupsIcon />} title={title} />
      <ListViewLocal
        listId="admin-station-groups"
        filters={ADMIN_STATION_GROUPS_FILTERS_CONFIG}
        queryFn={queryFn}
        ListComponent={AdminStationGroupsList}
        ListWrapper={Page.Content}
        enablePagination={false}
        showProgress
      />
    </Page>
  );
}
